import { DyAbstractInputField, IInputField } from './dyAbstractInputField';
import { some } from '../utils/array';
import { exists } from '../utils/generic';

export interface ITextInputField extends IInputField {
  allowedCharPattern?: string;
}

export class DyInputTextField extends DyAbstractInputField<HTMLInputElement, string, ITextInputField> {
  constructor(config?: ITextInputField, className = 'dy-text-field', inputType = 'text') {
    super(config, className, inputType);
  }

  protected postConstruct() {
    super.postConstruct();

    if (this.config.allowedCharPattern) {
      this.preventDisallowedCharacters();
    }
  }

  public setValue(value?: string | null, silent?: boolean): this {
    const ret = super.setValue(value, silent);

    if (this.eInput.value !== value) {
      this.eInput.value = exists(value) ? value : '';
    }

    return ret;
  }

  private preventDisallowedCharacters(): void {
    const pattern = new RegExp(`[${this.config.allowedCharPattern}]`);

    const preventDisallowedCharacters = (event: KeyboardEvent) => {
      if (event.key && !pattern.test(event.key)) {
        event.preventDefault();
      }
    };

    this.addManagedListener(this.eInput, 'keypress', preventDisallowedCharacters);

    this.addManagedListener(this.eInput, 'paste', e => {
      const text = e.clipboardData.getData('text');

      if (some(text, (c: string) => !pattern.test(c))) {
        e.preventDefault();
      }
    });
  }
}
